<script setup lang="ts">
  /**
   * Chrome-free layout for the split-screen auth pages: the page owns the whole
   * viewport, so its brand panel can run edge to edge. No top menu — those links
   * live inside the page itself.
   *
   * The register page states the Russia/Belarus service restriction inline,
   * against the country field it actually applies to; no layout-level banner is
   * raised here.
   */
  import { defineAsyncComponent } from 'vue'

  const IndexModal = defineAsyncComponent(() => import('@/components/modal/IndexModal.vue'))
</script>

<template>
  <div class="login-split-layout">
    <router-view />
  </div>
  <IndexModal />
  <IndexNotification />
</template>

<style scoped lang="scss">
  .login-split-layout {
    min-height: 100vh;
  }
</style>
